import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let UtilityClassComp;

class Utility_class extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: UtilityClassComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/base-components/utility-class-comp" */
      "../../../components/javascript/base-components/utility-class-comp"
    ).then(function(res) {
      UtilityClassComp = res.UtilityClassComp;
    }));

    
;
  }
}

export { Utility_class };
